var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "upload-popup", attrs: { role: "list" } }, [
      _c("div", { attrs: { role: "listitem" } }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://member.bilibili.com/platform/upload/text/apply",
            },
          },
          [_vm._v("专栏投稿")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { role: "listitem" } }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://member.bilibili.com/platform/upload/audio/frame",
            },
          },
          [_vm._v("音频投稿")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { role: "listitem" } }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://member.bilibili.com/platform/upload/sticker",
            },
          },
          [_vm._v("贴纸投稿")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { role: "listitem" } }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://member.bilibili.com/platform/upload/video/frame",
            },
          },
          [_vm._v("视频投稿")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { role: "listitem" } }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://member.bilibili.com/platform/upload-manager/article",
            },
          },
          [_vm._v("投稿管理")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { role: "listitem" } }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://member.bilibili.com/platform/home",
            },
          },
          [_vm._v("创作中心")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }